/**
 * Retorna as posições empatadas no melhor valor numérico finito.
 *
 * @param {number[]} pValues Valores comparáveis na ordem original.
 * @param {'higher'|'lower'} pCriterion Sentido explícito da comparação.
 * @returns {number[]} Posições dos melhores valores disponíveis.
 */
export const getBestValueIndexes = (pValues = [], pCriterion) => {
    const xFiniteValues = pValues
        .map((pValue, pIndex) => ({ index: pIndex, value: pValue }))
        .filter(pEntry => typeof pEntry.value === 'number' && Number.isFinite(pEntry.value));

    if (!xFiniteValues.length || !['higher', 'lower'].includes(pCriterion)) {
        return [];
    }

    const xBestValue = xFiniteValues.reduce((pBestValue, pEntry) => {
        if (pCriterion === 'higher') {
            return Math.max(pBestValue, pEntry.value);
        }

        return Math.min(pBestValue, pEntry.value);
    }, xFiniteValues[0].value);

    return xFiniteValues
        .filter(pEntry => pEntry.value === xBestValue)
        .map(pEntry => pEntry.index);
};

const comparisons = {
    getBestValueIndexes
};

export default comparisons;
